export default "__VITE_ASSET__b752bf50__"